import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';
import { PAYMENT_PROJECT_CONFIG } from '../../../../projects';

const Agreement: FC = () => {
  const { t } = useTranslation('subscription');

  return (
    <div className={styles.agreement}>
      <Typography
        className={styles.text}
        variant={Typographies.BODY_SMALL}
        component="p"
      >
        {t('general:payment_processed_by', 'The payment processed by')}{' '}
        {PAYMENT_PROJECT_CONFIG.getCompanyAddress(t)}
      </Typography>
    </div>
  );
};

export default Agreement;
